// 获取当前国际化状态封装在了上面的./langs/index.js中，相当于是初始化国际化
//import { getLanguage } from '@/i18n/langs/index'
import Cookies from 'js-cookie'
// 数据，外部可以通过 this.$store.state.language 调用
const state = {
  language: Cookies.get('language') || 'zh'
}
// 外部可以通过提交mutation来修改state中的值
// this.$store.commit("SET_LANGUAGE")
const mutations = {
  SET_LANGUAGE: (state, language) => {
    // 修改state并将其保存在Cookies中，这样用户下次打开仍然是上次选择的国际化状态
    state.language = language
    Cookies.set('language', language)
  },
}
// 官方推荐我们去提交一个actions，在actions中提交mutation再去修改state
// this.$store.dispatch("setLanguage")
const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js